import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import {
  ErrorSnacktOpen
} from "../../ErrorSnack/actions";

export const cargarModalObservacion = (openModal, observacion, idPaquete) => ({
  type: "CARGAR_MODAL_OBSERVACION",
  openModal,
  observacion,
  idPaquete,
});

export const CambiarObservacion = (observacion) => ({
  type: "CAMBIAR_OBSERVACION",
  observacion,
});

export const guardarObservacionPaquete = (idPaquete, observacion) => ({
  type: "GUARDAR_OBSERVACION",
  idPaquete,
  observacion,
});


export const cerrarModalObservacion = (cerrar) => ({
  type: "CERRAR_MODAL_OBSERVACION",
  cerrar,
});

export const abrirModalCaracteristicas = (openModal, caracteristicas) => ({
  type: "ABRIR_MODAL_CARACTERISTICAS",
  openModal,
  caracteristicas,
});


export const cerrarModalCaracteristicas = (cerrar) => ({
  type: "CERRAR_MODAL_CARACTERISTICAS",
  cerrar,
});

export const abrirModalDetalle = (openModal, totalClinica, totalHMQ, totalMonto, detalles) => ({
  type: "ABRIR_MODAL_DETALLE",
  openModal,
  totalClinica,
  totalHMQ,
  totalMonto,
  detalles,
});

export const cerrarModalDetalle = (cerrar) => ({
  type: "CERRAR_MODAL_DETALLE",
  cerrar,
});

export const cargarEditarPrestacion = (modalEditarPrestacion) => ({
  type: "CARGAR_EDITAR_PRESTACION",
  modalEditarPrestacion,
});

export const SeleccionarPrestacionEliminar = (idPrestacionEliminar) => ({
  type: "CAMBIAR_PRESTACION_ELIMINAR",
  idPrestacionEliminar,
});

export const SeleccionarPrestacionEditar = (idPrestacionEditar) => ({
  type: "CAMBIAR_PRESTACION_EDITAR",
  idPrestacionEditar,
});


export const OpenEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarModalObservacion(true));
};

export const CloseEliminarPrestacion = () => (dispatch) => {
  dispatch(cargarModalObservacion(false));
};

export const OpenEditarPrestacion = () => (dispatch) => {
  dispatch(cargarEditarPrestacion(true));
};

export const CloseEditarPrestacion = () => (dispatch) => {
  dispatch(cargarEditarPrestacion(false));
};

export const GuardarObservacion = (observacion, idPaquete) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/updateObservacionPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      Observacion: observacion,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("updateObservacionPaquete", result);
    dispatch(guardarObservacionPaquete(idPaquete, observacion));
  }), (error) => {
    trace.error("updateObservacionPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cambiar la observacion del paquete",
      error,
    ));
  });
};

export const cargarCaracteristicasPaquetes = (idPaquete) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/caracteristicasPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("caracteristicasPaquete", result);
    //console.log(result)
    dispatch(abrirModalCaracteristicas(true, result));
  }), (error) => {
    trace.error("caracteristicasPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cargar las caracteristicas del paquete",
      error,
    ));
  });
};

export const cargarDetallePaquete = (idPaquete, totalClinica, totalHMQ, totalMonto) => (dispatch) => {
  const globalState = store.getState().global;
  fetch(`${apiConfig.apiUri}/v1/paquetes/prestacionesPaquete`, {
    method: 'POST',
    body: JSON.stringify({
      idPaquete: idPaquete,
      token: globalState.token,
    }),
  }).then((res) => res.json().then((result) => {
    //trace.information("prestacionesPaquete", result);
    //console.log(result)
    dispatch(abrirModalDetalle(true, totalClinica, totalHMQ, totalMonto, result));
  }), (error) => {
    trace.error("prestacionesPaquete", error);
    dispatch(ErrorSnacktOpen(
      "Error al cargar las prestaciones del paquete",
      error,
    ));
  });
};